import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { COMPONENTS } from '../../../routers/constants'
import { TextLink } from '../../html/TextLink'
import { Element } from '../../html/element'
import { Switch } from '../../html/switch'
import { changeSettings, selectSettings } from './store/slice'
import { getAlertSettings } from './store/thunk'

export const AlertForCompany = () => {
  const dispatch = useDispatch()
  const checked = useSelector(selectSettings('hasProfileFollowingList'))

  const [followingProfileId, setFollowingProfileId] = useState()

  const onChange = (isCheck) => {
    dispatch(changeSettings({ hasProfileFollowingList: isCheck }))
  }

  useEffect(() => {
    dispatch(getAlertSettings())
      .unwrap()
      .then((res) => {
        setFollowingProfileId(
          res?.listAlertSettingsProfile?.find((item) => item.isFollowingList)
            ?.profileAlertId,
        )
      })
  }, [])

  const alertSettingRoute = COMPONENTS.alerts.components.alertSetting.route

  return (
    <div className="dFlex">
      <div>
        <Switch checked={checked} onChange={onChange} title={<>&nbsp;</>} />
      </div>

      <div>
        <Element className="fw600" style={{ color: '#191D25' }}>
          <Translate value="common.popup.followAlert.ALERT_FOR_COMPANY_TITLE" />
        </Element>
        <Element className="mt1" style={{ color: '#3A414B' }}>
          <TextLink
            value="common.popup.followAlert.ALERT_FOR_COMPANY_NOTE_1"
            labelLink="common.popup.followAlert.FOLLOWING_LIST"
            url={COMPONENTS.library.components.followingList.route}
            isTextDecoration={false}
          />
          &nbsp;
          <TextLink
            value="common.popup.followAlert.ALERT_FOR_COMPANY_NOTE_2"
            labelLink="common.popup.followAlert.HERE"
            url={
              followingProfileId
                ? `${alertSettingRoute}?profileId=${followingProfileId}`
                : alertSettingRoute
            }
            isTextDecoration={false}
          />
        </Element>
      </div>
    </div>
  )
}
